import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DemoFloatCardComponent } from './demo-float-card.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { ConsentModalComponent } from '../float-card/card-light/consent-modal/consent-modal.component';
@NgModule({
    declarations: [DemoFloatCardComponent, ConsentModalComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RecaptchaFormsModule, RecaptchaModule],
    exports: [DemoFloatCardComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DemoFloatCardModule {}